import * as React from "react";
import BeatLoader from "react-spinners/BeatLoader";
import { StyleClassAuto } from "../../Shared/Styles/Auto/StyleClassAuto";

export function LoadingSpinner({ className }: { className?: string }) {
    const defaultClassName = StyleClassAuto({
        textAlign: `center`,
        marginTop: `20px`,
    });

    return (
        <div className={className ?? defaultClassName}>
            <BeatLoader color={`#ffffff`} loading={true} />
        </div>
    );
}
